const initialState = true

const sidebarShow = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return rest.sidebarShow
    default:
      return state
  }
}

export default sidebarShow;